import { History } from "lucide-react";
import type React from "react";
import type { ChatMessageProps } from "./types";

const MessageContent = ({ content }: { content: string }) => (
  <div className="px-3 py-2 rounded-xl rounded-tr-none text-sm leading-relaxed shadow-sm bg-indigo-600 text-white overflow-hidden">
    <p className="whitespace-pre-wrap break-all">{content}</p>
  </div>
);

export const UserMessage: React.FC<ChatMessageProps> = ({ message, onRestore }) => {
  return (
    <div className="flex w-full mb-4 justify-end">
      <div className="flex flex-col items-end max-w-[90%] min-w-0">
        {message.content && <MessageContent content={message.content} />}
        <div className="flex items-center gap-2 mt-1 px-1">
          <span className="text-[10px] text-slate-600">
            {new Date(message.timestamp).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
          {onRestore && (
            <button
              onClick={onRestore}
              className="flex items-center gap-1 text-[10px] text-slate-500 hover:text-indigo-400 transition-colors px-1.5 py-0.5 rounded hover:bg-slate-800"
              title="Restore to this version"
            >
              <History size={10} />
              <span>Restore</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
